import { AccountHolder } from './bankaccounts/AccountHolder';
import { AccountNumber } from './bankaccounts/AccountNumber';
import { AccountType } from './bankaccounts/AccountType';
import { Bic } from './bankaccounts/Bic';
import { Currency } from './bankaccounts/Currency';
import { Iban } from './bankaccounts/Iban';
import { IsDefault } from './bankaccounts/IsDefault';
import { RoutingNumber } from './bankaccounts/RoutingNumber';
export const BankAccountsItem = {
    account_holder: AccountHolder,
    account_number: AccountNumber,
    account_type: AccountType,
    bic: Bic,
    currency: Currency,
    iban: Iban,
    is_default: IsDefault,
    routing_number: RoutingNumber,
};
